import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Award, Star } from 'lucide-react';
import { awards } from '../data/mock';

const Awards = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center">
            <h1 className="text-6xl font-bold text-white mb-6">Awards & Recognition</h1>
            <p className="text-2xl text-white text-opacity-70 max-w-3xl mx-auto">
              Honors received for excellence in Ayurvedic surgery, research, and humanitarian service
            </p>
          </motion.div>
        </div>
      </section>

      {/* Awards Timeline */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6">
          <div className="space-y-12">
            {awards.map((award, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="relative"
              >
                <div className={`flex items-start gap-8 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  {/* Year Badge */}
                  <div className="w-32 flex-shrink-0">
                    <div className="w-32 h-32 bg-[#00FFD1] bg-opacity-10 border-2 border-[#00FFD1] flex items-center justify-center">
                      <span className="text-3xl font-bold text-[#00FFD1]">{award.year}</span>
                    </div>
                  </div>

                  {/* Award Content */}
                  <div className="flex-1 p-8 bg-[#121212] border border-white border-opacity-25">
                    <div className="flex items-start gap-4 mb-4">
                      <Trophy className="text-[#00FFD1] flex-shrink-0" size={28} />
                      <div className="flex-1">
                        <h3 className="text-3xl font-bold text-white mb-2">{award.title}</h3>
                        <p className="text-[#00FFD1] text-lg mb-3">{award.organization}</p>
                        <p className="text-white text-opacity-85 leading-relaxed">{award.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Recognition */}
      <section className="py-20 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-6">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-5xl font-bold text-white mb-16 text-center"
          >
            Additional Recognition
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Red Cross Awards",
                description: "2 appreciation awards from district administration and IMA Gadag for exceptional service",
                icon: Award
              },
              {
                title: "Akshara Abhisheka",
                description: "Recognition for first aid training to social workers at Hassan, Karnataka (2005)",
                icon: Star
              },
              {
                title: "Resource Person",
                description: "Invited as expert resource person at national and international conferences",
                icon: Trophy
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="p-8 bg-black border border-white border-opacity-25 text-center"
              >
                <div className="w-16 h-16 bg-[#00FFD1] bg-opacity-10 flex items-center justify-center mx-auto mb-6">
                  <item.icon className="text-[#00FFD1]" size={32} />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{item.title}</h3>
                <p className="text-white text-opacity-70 leading-relaxed">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-32">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="p-12 bg-[#121212] border border-[#00FFD1] text-center"
          >
            <Star className="text-[#00FFD1] mx-auto mb-6" size={48} />
            <p className="text-3xl text-white text-opacity-85 leading-relaxed mb-6">
              "A visionary leader, a mentor to many, respected and revered in the medical fraternity, 
              treating patients with a heart full of compassion."
            </p>
            <div className="h-1 w-24 bg-[#00FFD1] mx-auto" />
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Awards;